import { inject, observer } from "mobx-react";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import "./style.scss";

const PersonalData = inject("mainStore")(
    observer(({ mainStore }) => {
        const { thirdParam } = useParams();
        const [data, setData] = useState(null);

        useEffect(() => {
            const fetchData = async () => {
                const resp = await mainStore.getByUrl("/app_rispromo_supply/vend_info", { vendorId: thirdParam });
                if (resp && resp.data) {
                    setData(resp.data);
                } else {
                    mainStore.setMainStore("isNotFound", true);
                }
            };

            fetchData();
        }, []);

        return (
            data && (
                <div className="personal-data">
                    <h2>Согласие на обработку персональных данных</h2>
                    <ol>
                        <li>
                            Я даю свое согласие {data.vendorInfo?.fullOpf} (далее – Оператор, ИНН: {data.vendorInfo?.INN}, адрес: {data.vendorInfo?.address}) на обработку моих персональных данных: адрес электронной почты, ФИО, номер мобильного
                            телефона (вместе или раздельно, в зависимости от принимаемой формы).
                        </li>

                        <li>Оператор обрабатывает персональные данные с целью предоставления доступа к сервисам, информации и/или материалам, содержащимся на веб-сайте или запрашиваемых мной.</li>

                        <li>Моё согласие является конкретным, предметным, информированным, осознанным и однозначным.</li>

                        <li>
                            Оператор обрабатывает персональные данные следующими способами: сбор, запись, систематизацию, накопление, хранение, уточнение (обновление, изменение), извлечение, использование, передачу (распространение, предоставление,
                            доступ), блокирование, удаление, уничтожение.
                        </li>

                        <li>Оператор обрабатывает персональные данные с использованием средств автоматизации.</li>

                        <li>Оператор обрабатывает персональные данные в соответствии с Политикой в отношении обработки персональных данных, размещенной по адресу: {data.vendorInfo?.address}.</li>

                        <li>Согласие действует с момента его предоставления и до момента отзыва Согласия.</li>

                        <li>Я вправе отозвать согласие путем направления Оператору заявления:</li>
                        <p>8.1. в письменной форме по адресу: {data.vendorInfo?.address};</p>
                        <li>
                            Оператор прекращает обработку персональных данных с момента получения заявления, а персональные данные подлежат уничтожению, если отсутствуют иные правовые основания для обработки, установленные законодательством
                            Российской Федерации. Обработка персональных данных прекращается по достижении цели обработки персональных данных, по получению отзыва согласия на получение новостной и рекламной рассылки и/или на обработку персональных
                            данных или исключения Оператора из Единого государственного реестра юридических лиц.
                        </li>
                    </ol>
                </div>
            )
        );
    }),
);

export default PersonalData;
